module.exports = __webpack_public_path__ + "static/media/1002132MF.d2966569.jpg";